import { render } from "./ChurchSettings.vue?vue&type=template&id=bfac1c98&scoped=true"
import script from "./ChurchSettings.vue?vue&type=script&lang=js"
export * from "./ChurchSettings.vue?vue&type=script&lang=js"

import "./ChurchSettings.vue?vue&type=style&index=0&id=bfac1c98&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfac1c98"]])

export default __exports__